import { render, staticRenderFns } from "./PaygeTransferInformation.vue?vue&type=template&id=bec4df7c&scoped=true&"
import script from "./PaygeTransferInformation.vue?vue&type=script&lang=js&"
export * from "./PaygeTransferInformation.vue?vue&type=script&lang=js&"
import style0 from "./PaygeTransferInformation.vue?vue&type=style&index=0&id=bec4df7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec4df7c",
  null
  
)

export default component.exports